import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
//
import { CLASSES, COLORS } from '../../assets/styles/styles'

export default function ButtonX({
  label = 'Click',
  className = '',
  isLoading = false,
  border='0',
  disabled = false,
  onClick,
  color = COLORS.theme,
  textColor = COLORS.white,
  style,
  ...rest
}) {
  // const navigate = useNavigate();
  const [opacity, setOpacity] = useState(1)

  const onBUttonClick = () => {
    setTimeout(() => {
      setOpacity((prevValue) => {
        if (prevValue === 1) {
          return prevValue
        } else return 0.8
      })
    }, 100)
  }
  return (
    <Button
      disabled={isLoading || disabled}
      className={`mr-0 border-${border} ${CLASSES.content_center} ${className}`}
      onClick={(e) => {
        onBUttonClick()
        onClick(e)
      }}
      onMouseEnter={() => setOpacity(0.8)}
      onMouseDown={() => setOpacity(0.9)}
      onMouseLeave={() => setOpacity(1)}
      style={{
        backgroundColor: color,
        minHeight: 40,
        color: textColor,
        fontSize: 14,
        opacity: disabled ? 0.5 : opacity,
        ...style,
      }}
      {...rest}
    >
      {!isLoading ? label : 'loading..'}
    </Button>
  )
}
